import * as React from "react";

import {
  AnalyticsConfigurationProvider,
  AnalyticsProvider,
  createAnalyticsContext,
  useAnalyticsOtpGtm,
} from "../../../Common";

import { useReactMyBagInitialState } from "../react-my-bag-initial-state-provider";

import { ReactMyBagAnalyticsInterface } from "./analytics-interface";
import { useAnalyticsXO } from "./analytics-xo";
import { useAnalyticsGtm } from "./analytics-gtm";
import { useAnalyticsTripleWhale } from "./analytics-triplewhale";

export const [analyticsContext, useMyBagAnalytics] =
  createAnalyticsContext<ReactMyBagAnalyticsInterface>();

const MyBagAnalyticsProvider_Implementations: React.FunctionComponent = (
  props
) => {
  const analyticsXO = useAnalyticsXO();
  const analyticsGtm = useAnalyticsGtm();
  const analyticsOtpGtm = useAnalyticsOtpGtm<ReactMyBagAnalyticsInterface>();
  const analyticsTripleWhale = useAnalyticsTripleWhale();

  const implementations = React.useMemo(
    () => [
      analyticsXO,
      analyticsGtm,
      analyticsOtpGtm,
      analyticsTripleWhale,
    ],
    [analyticsXO, analyticsGtm, analyticsOtpGtm, analyticsTripleWhale]
  );

  return (
    <AnalyticsProvider
      context={analyticsContext}
      implementations={implementations}
    >
      {props?.children || []}
    </AnalyticsProvider>
  );
};

export const MyBagAnalyticsProvider: React.FunctionComponent = (props) => {
  return (
    <AnalyticsConfigurationProvider useInitialState={useReactMyBagInitialState}>
      <MyBagAnalyticsProvider_Implementations>
        {props.children || []}
      </MyBagAnalyticsProvider_Implementations>
    </AnalyticsConfigurationProvider>
  );
};
